import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {PartitionOPEEnum} from "./PartitionOPEEnum";

class PartitionDTO {
  id!: number;
  name!: string;
  parentId?: number;
  active!: boolean;
  notes?: string;

  additionalInfo?: PartitionAdditionalInfoDTO;
}

class PartitionAdditionalInfoDTO {
  address?: AddressDTO;
}

class AddressDTO {
  number?: string;
  street?: string;
  city?: string;
  cap?: string;
  telephone?: string;
  province?: string;
}

class O {
  partition!: PartitionDTO;
}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}

export class GetPartitionDetailCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(PartitionOPEEnum.GetPartitionDetail);
    this.i = new I();
    this.o = new O();
  }
}
